import { GenericFailure } from '@playq/services-shared';
import { AppInventoryPackage } from '@playq/octopus2-economy';

import { IInvokeScriptsHook } from '/common/scripts/types';
import { UseMutationOptionsExtended } from '/api/service-hooks';

import { useEitherMutationScripted } from '../scriptsService/useEitherMutationScripted';

import { IAppsPackageCreateOptionsVariables, ICreatePackageParams } from './types';
import { appsPackagesService, appsPackagesServiceName, createPackageMutationKey } from './constants';

export const useAppsPackageCreateScripted = (
  scriptsResolver: IInvokeScriptsHook,
  options?: UseMutationOptionsExtended<AppInventoryPackage, GenericFailure | Error, IAppsPackageCreateOptionsVariables>
) =>
  useEitherMutationScripted<ICreatePackageParams, AppInventoryPackage, IInvokeScriptsHook>({
    serviceMethod: appsPackagesService.create.bind(appsPackagesService),
    scriptsResolver,
    snackbarMessageMetadata: {
      serviceName: appsPackagesServiceName,
      mutationType: 'package creation',
    },
    options: {
      mutationKey: createPackageMutationKey,
      ...options,
    },
  });
